import React from "react";
import { NavLink } from "react-router-dom";

const NavLinkSecondary = (props) => {
  return (
    <NavLink
      data-testid="navigation"
      {...props}
      style={({ isActive }) => ({
        fontWeight: isActive ? "bold" : "normal",
      })}
    />
  );
};

export default NavLinkSecondary;
